import { twMerge } from 'tailwind-merge';
import { useAppTheme } from 'src/utils/theme';
import { ENV_MODE } from 'src/utils';

const Logo = ({ className }: { className?: string }) => {
  const { isDark } = useAppTheme();

  return (
    <img
      src={`/mode/${ENV_MODE}/logo-${isDark ? 'dark' : 'light'}.svg`}
      alt={import.meta.env.VITE_APP_TITLE}
      className={twMerge('inline-block align-middle h-10 mb-6', className)}
    />
  );
};

export default Logo;
